import React from 'react';

import moment from 'moment';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import Element from '../../../../components/element';
import Button from '../../../../components/Button';
import Flex from '../../../../components/flex';
import Text from '../../../../components/text';
import IconDefaultProfile from '../../../../assets/icons/IconDefaultProfile.jpg';

const getReduxData = state => {
  return {
    user: state.containers.app.get('user')
  };
};

const Demographics = ({ healthReportData }) => {
  const data = useSelector(getReduxData);
  const { user } = data;
  const capitalizeFirstLetter = string => {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
  };

  return (
    <Element>
      <Element>
        <Text family="GTAM" size="24px" color="#222222">
          {get(healthReportData, 'demographics.full_name.value')}
        </Text>
      </Element>
      <Flex marginTop="20px">
        <Element width="100px" height="100px">
          <img style={{ "borderRadius": "100px" }}
            src={
              get(healthReportData, 'demographics.headShot')
                ? get(healthReportData, 'demographics.headShot')
                : IconDefaultProfile
            }
          />
        </Element>
        <Element marginLeft="150px">
          <Text size="12px" family="GTAR" color="#959595" marginBottom="5px">
            Date of Birth
          </Text>
          <Text size="14px" family="GTAM" color="#222222" marginTop="0px">
            {moment(
              get(healthReportData, 'demographics.birth_date.value')
            ).format('MM/DD/YYYY')}
          </Text>
          <Text size="12px" family="GTAR" color="#959595" marginBottom="5px">
            Age
          </Text>
          <Text size="14px" family="GTAM" color="#222222" marginTop="0px">
            {get(healthReportData, 'demographics.age.value')} Years
          </Text>
          <Text size="12px" family="GTAR" color="#959595" marginBottom="5px">
            Gender
          </Text>
          <Text size="14px" family="GTAM" color="#222222" marginTop="0px">
            {get(healthReportData, 'demographics.gender.value')}
          </Text>
        </Element>
        <Element marginLeft="150px">
          <Text size="12px" family="GTAR" color="#959595" marginBottom="5px">
            Race
          </Text>
          <Text size="14px" family="GTAM" color="#222222" marginTop="0px">
            {get(healthReportData, 'demographics.race.value')}
          </Text>
          <Text size="12px" family="GTAR" color="#959595" marginBottom="5px">
            Ethnicity
          </Text>
          <Text size="14px" family="GTAM" color="#222222" marginTop="0px">
            {get(healthReportData, 'demographics.ethnicity.value')}
          </Text>
          <Text size="12px" family="GTAR" color="#959595" marginBottom="5px">
            Handedness
          </Text>
          <Text size="14px" family="GTAM" color="#222222" marginTop="0px">
            {capitalizeFirstLetter(
              get(healthReportData, 'demographics.dexterity.value')
            )}
          </Text>
        </Element>
      </Flex>
    </Element>
  );
};

export default Demographics;
